export const KanbanIcon = (
  <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 1.5H18C19.0938 1.5 20 2.40625 20 3.5V13.5C20 14.625 19.0938 15.5 18 15.5H2C0.875 15.5 0 14.625 0 13.5V3.5C0 2.40625 0.875 1.5 2 1.5ZM6 3.5H2V13.5H6V3.5ZM8 3.5V13.5H12V3.5H8ZM18 3.5H14V13.5H18V3.5Z" fill="currentColor" />
  </svg>
);